var redefine = require('./$.redefine');
module.exports = function(target, src){
  for(var key in src)redefine(target, key, src[key]);
  return target;
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/core-js/library/modules/$.redefine-all.js
// module id = 340
// module chunks = 174 178 179 193 194